import { createContext, useContext } from 'react';
import { GetWebhooksState } from '../hooks/useGetWebhooks';

export interface DestinationsContextState {
  savedWebhooks: GetWebhooksState;
}

export const DESTINATIONS_CONTEXT_STATE: DestinationsContextState = {
  savedWebhooks: {} as GetWebhooksState,
};

export const DestinationsContext = createContext<DestinationsContextState>(
  DESTINATIONS_CONTEXT_STATE,
);
export const useDestinationsContext = () => useContext(DestinationsContext);
